export const getUserToken = () => {
  return localStorage.getItem('UserIdToken');
};
export const setUserToken = (token) => {
  localStorage.setItem('UserIdToken', `${token}`);
};
export const getUserRefreshToken = () => {
  return localStorage.getItem('UserRefreshToken');
};
export const setUserRefreshToken = (token) => {
  localStorage.setItem('UserRefreshToken', `${token}`);
};
export const unsetUserToken = () => {
  localStorage.removeItem('UserIdToken');
};
export const unsetUserRefreshToken = () => {
  localStorage.removeItem('UserRefreshToken');
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo')) || null;
};
export const setUserInfo = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};
export const unsetUserInfo = () => {
  localStorage.removeItem('userInfo');
};

export const setTableParams = (params) => {
  localStorage.setItem('tableParams', JSON.stringify(params));
};

export const getTableParams = () => {
  return JSON.parse(localStorage.getItem('tableParams')) || {};
};
